<template>
  <div>
    <!-- <button class="btn btn-info mb-2" @click.prevent="openItemModal">
      <i class="fas fa-plus"></i> Thêm
    </button> -->
    <b-table
    id="my-table"
    bordered
    head-variant="dark"
    hover
    responsive
    striped
    small
    table-variant="light"
    :fields="fields"
    :items="items">
    <template slot="top-row">
      <td></td>
      <td>
        <b-form-input
          v-model="assetId_filter"
          @keydown.enter.prevent="queryItem"
        ></b-form-input>
      </td>
      <td>
        <b-form-input
          v-model="name_filter"
          @keydown.enter.prevent="queryItem"
        ></b-form-input>
      </td>
      <td>
        <b-form-select
          v-model="assetTypeId_filter"
          :options="Assettypes"
          value-field="id"
          text-field="type"
          @change="queryItem"
        >
        </b-form-select>
      </td>
      <!-- <td>
        <multiselect
          v-model="employeeId_filter"
          placeholder
          track-by="id"
          label="hovaten"
          selectedLabel="Đang chọn"
          select-label="Enter để chọn"
          deselectLabel="Enter để xóa"
          :searchable="true"
          :options="employees"
          @select="queryItemParam"
          @remove="queryItemRemove"
        >
        </multiselect>
      </td> -->
      <!-- <td>
        <b-form-select
          v-model="position_filter"
          :options="Positions"
          value-field="id"
          text-field="pickListValue"
          @change="queryItem"
        >
        </b-form-select>
      </td> -->
      <td>
        <b-form-select
          v-model="departmentId_filter"
          :options="Departments"
          value-field="id"
          text-field="tendonvi"
          @change="queryItem"
        >
        </b-form-select>
      </td>
      <td>
        <b-form-select
          v-model="roomId_filter"
          :options="Rooms"
          value-field="id"
          text-field="name"
          @change="queryItem"
        >
        </b-form-select>
      </td>
      <!-- <td>
        <b-form-input
          v-model="assetStatus_filter"
          :options="AssetStatus"
          value-field="id"
          text-field="pickListValue"
          @change="queryItem"
        ></b-form-input>
      </td> -->
      <!-- @keydown.enter.prevent="queryItem" -->
      <td>
        <b-form-input
          v-model="assetStatus_filter"
          @keydown.enter.prevent="queryItem"
        ></b-form-input>
      </td>

      <td>
        <b-form-select
          v-model="status_filter"
          :options="Status"
          value-field="id"
          text-field="pickListValue"
          @change="queryItem"
        >
        </b-form-select>
      </td>
      <td>
        <b-form-input
          v-model="recievedDate_filter"
          @keydown.enter.prevent="queryItem"
          type="date"
        ></b-form-input>
      </td>
      <td>
        <b-form-input
          v-model="notation_filter"
          @keydown.enter.prevent="queryItem"
        ></b-form-input>
      </td>
    </template>
    <template #cell(STT)="data">
      {{ data.index + 1 }}
    </template>
    <template v-slot:cell(position)="data">
      {{
        data.item.position == null
          ? ""
          : findFirst(vitricongviecs, data.item.position)
      }}
    </template>
    <!-- Sua hien trang -->
    <template v-slot:cell(status)="data">
      {{
        data.item.status == null
          ? ""
          : findFirst(hientrangs, data.item.status)
      }}
    </template>
    <template v-slot:cell(roomId)="data">
      {{
        data.item.roomId == null
          ? ""
          : findRoom(rooms, data.item.roomId)
      }}
    </template>
    <template v-slot:cell(action)="data" v-if="asset_cud">
      <div>
        <b-link
          class="text-primary"
          href="#"
          @click="goTo(data.item)"
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
        <!-- <b-link
          class="text-danger"
          href="#"
          @click.prevent="deleteItem(data)"
        >
          <i class="fas fa-trash"></i>
        </b-link> -->
      </div>
    </template>
    <template v-slot:cell(returnedDate)="data">
      <span> {{ data.item.returnedDate | moment("DD/MM/YYYY") }} </span>
    </template>
    </b-table>
  </div>
</template>

<script>
  import axios from "axios";
  import Multiselect from "vue-multiselect";
  import "vue-multiselect/dist/vue-multiselect.min.css";

  export default {
    name: "TaiSan",
    props: ["item"],
    components: {
      // Multiselect,
    },
    data() {
      return {
        fields: [
          {
            key: "STT",
            label: "No.",
            // label: "STT",
            thClass: "align-middle",
            thStyle: { width: "15px", textAlign: "center" },
          },
          {
            key: "assetId",
            label: "Asset ID",
            // label: "Mã TS",
            sortable: true,
            thClass: "align-middle",
            thStyle: { width: "80px !important", textAlign: "center" },
          },
          {
            key: "name",
            label: "Asset name",
            // label: "Tên tài sản",
            sortable: true,
            thClass: "align-middle",
            thStyle: { width: "200px !important", textAlign: "center" },
          },
          {
            key: "assetTypeId",
            label: "Asset type",
            // label: "Loại tài sản",
            sortable: true,
            thClass: "align-middle",
            thStyle: { width: "150px !important", textAlign: "center" },
          },
          // {
          //   key: "employeeId",
          //   label: "Nhân viên",
          //   sortable: true,
          //   thStyle: { width: "250px !important" },
          // },
          // {
          //   key: "position",
          //   label: "Chức danh",
          //   sortable: true,
          //   thStyle: { width: "200px !important" },
          // },
          {
            key: "departmentId",
            label: "Purchased by",
            // label: "Công ty",
            sortable: true,
            thClass: "align-middle",
            thStyle: { textAlign: "center" },
            // thStyle: { width: "200px !important" },
          },
          {
            key: "roomId",
            label: "Located at",
            // label: "Khu vực",
            sortable: true,
            thClass: "align-middle",
            thStyle: { textAlign: "center" },
            // thStyle: { width: "200px !important" },
          },
          {
            key: "assetStatus",
            label: "Asset Status",
            // label: "Tình trạng",
            sortable: true,
            thClass: "align-middle",
            thStyle: { width: "100px", textAlign: "center" },
          },
          {
            key: "status",
            label: "Status",
            // label: "Hiện trạng",
            sortable: true,
            thClass: "align-middle",
            thStyle: { width: "120px", textAlign: "center" },
          },
          {
            key: "returnedDate",
            label: "Issued Date",
            // label: "Ngày cấp",
            sortable: true,
            tdClass: "text-center",
            thClass: "align-middle",
            thStyle: { width: "50px", textAlign: "center" },
          },
          {
            key: "notation",
            label: "Note",
            // label: "Ghi chú",
            sortable: true,
            thClass: "align-middle",
            thStyle: { textAlign: "center" },
          },
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: { width: "50px !important" },
          },
        ],

        items: [],
        assets: [],
        rooms: [],
        query: null,
        hientrangs: [],
        // tinhtrangs:[],
        item_selected_assetId: "",
        modalShow: false,
        vitricongviecs: [],
        assettypes: [],
        employees: [],
        departments: [],

        assetId_filter: "",
        name_filter: "",
        assetTypeId_filter: "",
        employeeId_filter: this.item.id,
        position_filter: "",
        departmentId_filter: "",
        roomId_filter: "",
        assetStatus_filter: "",
        status_filter: "",
        recievedDate_filter: "",
        notation_filter: "",
      };
    },
    created() {
      if (this.item != null) this.initData();
    },
    computed: {
      //Permission Buuton Them Taisan/Them LoaiTaiSan/Them khu vuc
      asset_cud() {
        return this.$store.getters.hasPermission("asset_cud");
      },
      asset_type_rcud() {
        return this.$store.getters.hasPermission("asset_type_rcud");
      },
      asset_room_rcud() {
        return this.$store.getters.hasPermission("asset_room_rcud");
      },

      Assettypes() {
        const null_value = { id: "", type: "" };
        var result = this.assettypes.slice();
        result.unshift(null_value);

        return result;
      },

      Positions() {
        const null_value = { id: "", pickListValue: "" };
        var result = this.vitricongviecs.slice();
        result.unshift(null_value);

        return result;
      },

      Departments() {
        const null_value = { id: "", tendonvi: "" };
        var result = this.departments.slice();
        result.unshift(null_value);

        return result;
      },

      Rooms() {
        const null_value = { id: "", name: "" };
        var result = this.rooms.slice();
        result.unshift(null_value);

        return result;
      },

      Status() {
        const null_value = { id: "", pickListValue: "" };
        var result = this.hientrangs.slice();
        result.unshift(null_value);

        return result;
      },
      // AssetStatus() {
      //   const null_value = { id: "", pickListValue: "" };
      //   var result = this.tinhtrangs.slice();
      //   result.unshift(null_value);

      //   return result;
      // },

    },

    // beforeRouteEnter(to, from, next) {
    //   axios
    //     .all([
    //       axios.get("/api/picklist?q=vitricongviec"),
    //       axios.get("/api/asset", { params: to.query }),
    //       axios.get("/api/Room"),
    //       axios.get("/api/picklist?q=tinhtrangtaisan"),
    //       axios.get("/api/assettype"),
    //       axios.get("/api/employee/getall"),
    //       axios.get("/api/department"),
    //     ])
    //     .then(
    //       axios.spread(
    //         (
    //           picklist,
    //           asset,
    //           room,
    //           tinhtrangtaisan,
    //           assettype,
    //           employee,
    //           department
    //         ) => {
    //           next((vm) =>
    //             vm.initData(
    //               picklist.data,
    //               asset.data,
    //               room.data,
    //               tinhtrangtaisan.data,
    //               assettype.data.items,
    //               employee.data,
    //               department.data
    //             )
    //           );
    //         }
    //       )
    //     );
    // },

    // beforeRouteUpdate(to, from, next) {
    //   axios
    //     .get("/api/asset", { params: to.query })
    //     .then((response) => {
    //       this.items = response.data;
    //       // next();
    //     })
    //     .catch((err) => {
    //       // next();
    //     });
    // },
    methods: {
      initData()
      {
        axios
        .all([
          // axios.get("/api/picklist?q=vitricongviec"),
          axios.get("/api/asset",{params: {q: '|||' + this.item.id + '|||||||'}}),
          //axios.get("/api/asset"),
          axios.get("/api/Room"),
          axios.get("/api/picklist?q=tinhtrangtaisan"),
          // axios.get("/api/picklist?q=tinhtrangtaisan2"),
          axios.get("/api/assettype"),
          // axios.get("/api/employee/getall"),
          axios.get("/api/department"),
        ])
        .then(
          axios.spread((assets, rooms, tinhtrangtaisans, assettypes, departments) => {
            this.items = assets.data;
            // this.vitricongviecs = picklists.data.filter((x) => x.pickListType == "vitricongviec");
            this.rooms = rooms.data;
            //Tinhtrangtaisan trong pickuplist = hientrang = trangthaisudung
            //trinhtrangtaisan2 trong pickuplist = tinhtrang = trangthaitaisan
            this.hientrangs = tinhtrangtaisans.data;
            // this.tinhtrangs = tinhtrangtaisans2.data; //Chua link nen chua co
            this.assettypes = assettypes.data.items; // thieu items
            // this.employees = employees.data;
            this.departments = departments.data;
          })
        )
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
      },

      initHistoryData(data) {
        this.histories = data;
      },

      addItem() {
        this.$router.push(`/add_asset`);
      },

      addAssetType() {
        this.$router.push(`/asset_type`);
      },

      addRoom() {
        this.$router.push(`/asset_room`);
      },

      updateItem(item) {
        this.$router.push(`/edit_asset/${item.assetId}`);
      },

      goTo(item) {
        this.$router.push(`/edit_asset/${item.assetId}`);
      },

      findFirst(list, id) {
        const temp = list.find(function(el) {
          if (el.id == id) return el;
        });

        return temp == null ? "" : temp.pickListValue;
      },

      findRoom(list, id) {
        const temp = list.find(function(el) {
          if (el.id == id) return el;
        });

        return temp == null ? "" : temp.name;
      },

      // queryItemParam(param) {
      //   if (param == null) this.employeeId_filter = "";
      //   else this.employeeId_filter = param.id;
      //   this.queryItem();
      // },

      // queryItemRemove() {
      //   this.employeeId_filter = "";
      //   this.queryItem();
      // },

      queryItem() {
        // let temp = "-1";

        // if (this.employeeId_filter == null) this.employeeId_filter = "";
        // else if (typeof this.employeeId_filter == "object") {
        //   temp = this.employeeId_filter;
        //   this.employeeId_filter = this.employeeId_filter.id;
        // }
        let query = Object.assign({}, this.$route.query);
        query.q =
          this.assetId_filter +
          "|" +
          this.name_filter +
          "|" +
          this.assetTypeId_filter +
          "|" +
          this.employeeId_filter +
          "|" +
          this.position_filter +
          "|" +
          this.departmentId_filter +
          "|" +
          this.roomId_filter +
          "|" +
          this.assetStatus_filter +
          "|" +
          this.status_filter +
          "|" +
          this.recievedDate_filter +
          "|" +
          this.notation_filter;


        // if (temp != "-1") this.employeeId_filter = temp;
        // this.$router.push({ query: query });
        axios
        .all([
          axios.get("/api/asset",{params: {q: query.q}}),
          // axios.get("/api/Room"),
          // axios.get("/api/picklist?q=tinhtrangtaisan"),
          // axios.get("/api/assettype"),
          // axios.get("/api/department"),
        ])
        .then(
          axios.spread((assets, rooms, tinhtrangtaisans, assettypes, departments) => {
            this.items = assets.data;
            // this.rooms = rooms.data;
            // this.hientrangs = tinhtrangtaisans.data;
            // this.assettypes = assettypes.data.items; // thieu items
            // this.departments = departments.data;
          })
        )
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
      },
    },
  };
  </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>